<div class="modal-header">
	<h5 class="modal-title">Update Phone Number</h5>
	<button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
	<app-alert
		[dismissible]="true"
		content="To update your phone number, we'll send a verification code to the new number you enter.
You'll need to enter the code to confirm and complete the update."
	></app-alert>
	<form [formGroup]="form" class="body">
		<app-phone-number-control [formGroup]="form" name="phoneNumber"></app-phone-number-control>

		<ng-container *ngIf="verificationId">
			<app-alert
				[dismissible]="true"
				content="A verification code has been sent to your new phone number. Please enter the code below to confirm the update."
			></app-alert>
			<app-standard-control
				type="text"
				[formGroup]="form"
				name="verificationCode"
				label="Verification Code"
				placeholder="Enter the verification code"
				labelPlacement="floating"
			></app-standard-control>
		</ng-container>
	</form>
</div>
<div class="modal-footer">
	<ng-container *ngIf="!verificationId">
		<button
			id="verificationCodeButton"
			type="button"
			[disabled]="verificationCodeLoading || phoneNumber.invalid || phoneNumber.pristine"
			class="btn btn-sm btn-primary btn-width"
			(click)="getVerificationCode()"
		>
			<ng-container *ngIf="verificationCodeLoading; else notLoading">
				<div class="spinner-border spinner-border-sm" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</ng-container>
			<ng-template #notLoading> Get Verification Code </ng-template>
		</button>
	</ng-container>

	<ng-container *ngIf="verificationId">
		<button
			type="button"
			[disabled]="updatingPhoneNumber || !verificationId || verificationCode.invalid || verificationCode.pristine"
			class="btn btn-sm btn-primary btn-width"
			(click)="updatehoneNumber()"
		>
			<ng-container *ngIf="updatingPhoneNumber; else notSaving">
				<div class="spinner-border spinner-border-sm" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</ng-container>
			<ng-template #notSaving> Save </ng-template>
		</button>
	</ng-container>
</div>
